import React from "react";
import { Sticky, StickyPositionType } from "@fluentui/react";

const CustomDetailsHeader = ({ detailsHeaderProps, defaultRender, handleHeaderChange }) => {
    const headerProps = handleHeaderChange(detailsHeaderProps);
    return (
        <Sticky
            stickyPosition={StickyPositionType.Header}
            isScrollSynced
            stickyClassName="page-frame-table-header-sticky"
        >
            {defaultRender(headerProps)}
        </Sticky>
    );
};

export default CustomDetailsHeader;
